import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

export default function RoomsPage() {
  const [data, setData] = useState(null);
  useEffect(() => { http.get("/public/property").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <div>
      <PublicHeader />
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16">
        <div className="eyebrow mb-3">The Suites</div>
        <h1 className="h1-hero text-5xl md:text-6xl mb-4">Our Accommodation</h1>
        <p className="mb-12 max-w-2xl" style={{ color: "var(--muted)" }}>A comfortable Himalayan home designed for families, friends and travellers who want to experience the mountains together.</p>
        <div className="grid md:grid-cols-2 gap-8">
          {data.rooms.map((r, i) => {
            const assigned = data.gallery.filter((g) => g.room_id === r.id).sort((a, b) => ((b.is_cover ? 1 : 0) - (a.is_cover ? 1 : 0)) || (a.sort_order - b.sort_order));
            const roomImgs = data.gallery.filter((g) => g.category === "Rooms" || g.category === "Bedrooms");
            const roomImg = assigned[0] || roomImgs[i] || roomImgs[0];
            return (
            <div key={r.id} className="card" data-testid={`rooms-page-room-${i}`}>
              {roomImg && (
                <img src={roomImg.image_url} alt={roomImg.alt_text || r.name} className="w-full aspect-[4/3] object-cover rounded-xl mb-5" loading="lazy" />
              )}
              <h3 className="font-serif text-3xl mb-2">{r.name}</h3>
              <p className="mb-4" style={{ color: "var(--muted)" }}>{r.description}</p>
              <div className="flex flex-wrap gap-2">
                {r.bed_type && <span className="badge-pine">{r.bed_type} Bed</span>}
                {r.capacity > 0 && <span className="badge-pine">Sleeps {r.capacity}</span>}
                {r.view && <span className="badge-pine">{r.view}</span>}
              </div>
            </div>
            );
          })}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
